import { timePicker40DaySupportEnabled } from "constants/machineConfig";

export const defaultRangeSelectListItems = [
  {
    label: 'today',
    value: 'today'
  },
  {
    label: 'yesterday',
    value: 'yesterday'
  },
  {
    label: 'this week',
    value: 'this-week'
  },
  {
    label: 'last week',
    value: 'last-week'
  },
  {
    label: 'last 2 weeks',
    value: 'last-2-weeks'
  },
  {
    label: 'this month',
    value: 'this-month'
  },
  {
    label: 'last 30 days',
    value: 'last-30-days'
  },
  ...(timePicker40DaySupportEnabled ? [{
    label: 'last 40 days',
    value: 'last-40-days'
  }] : []),
];

export const defaultTimeRangeSelectListItems = [
  {
    label: '15 min',
    value: '15-minutes'
  },
  {
    label: '30 min',
    value: '30-minutes'
  },
  {
    label: '2 hours',
    value: '2-hours'
  },
  {
    label: '4 hours',
    value: '4-hours'
  },
  {
    label: '8 hours',
    value: '8-hours'
  },
  {
    label: '24 hours',
    value: '24-hours'
  }
];
